  <!--
   功能名称:千里眼平台(技师)-会员管理(余额筛选)
   开发人:梁高权
   创建时间:2021/03/14
   最后修改时间:2021/03/14
   -->
<template>
  <van-form @submit="onSubmit">
    <div class="form-item">
      <div class="title">会员卡余额</div>
      <GRadioButton :radioList="cardNumList" :value="num" @Gradio="Gradio" />
    </div>
    <div class="form-item">
      <div class="title">自定义</div>
      <van-field v-model="num" maxlength="10" name="card_num" type="digit" label="会员卡余额低于" label-width="120px">
          <template #button>元</template>
      </van-field>
    </div>
    <div class="button-box">
      <van-button  round  color="#666666" native-type="button" plain @click="reset">重置</van-button>
      <van-button round color="#4F57FB"  type="info" native-type="submit">确定</van-button>
    </div>
  </van-form>
</template>

<script>
import { Toast } from 'vant';
export default{
  name:'cardNum',
  components:{'GRadioButton':()=>import('@/components/GRadioButton')},
  props:{
    card_num:{
      type:Number,
      default:0
    }
  },
  watch:{
    card_num:{
      handler(newVal,oldVal){
        this.num=newVal
      },
      immediate:true,
      deep:true
    }
  },
  data() {
    return {
      cardNumList:[
        {title:'100元',value:100},
        {title:'200元',value:200},
        {title:'500元',value:500},
        {title:'1000元',value:1000}
      ],
      num: ''
    };
  },
  methods: {
    onSubmit(values) {
      if(!values.card_num) values.card_num=0
      else values.card_num=parseFloat(values.card_num);
      if (values.card_num>=100&&values.card_num <= 10000000) {
        this.$emit('onConfirm',values)
      } else {
        Toast.fail('卡余额不能低于100元')
      }

    },
    reset(){
      this.num=0
      this.$emit('onReset','重置所有')
    },
    Gradio(value){
      this.num=value
    }
  }
}
</script>

<style lang="scss" scoped>
 .form-item{
   padding: 0 35px 25px;
   border-bottom: 1px solid #F0F0F0;
   .title{font-size: 24px;color: #999;font-weight: 500;line-height: 70px;}
   /deep/.van-cell__title{line-height: 50px;font-size: 28px;color: #666;font-weight: 500;}
   /deep/.van-field__body{
     input{
       border: 2px solid #EEEEEE;
       padding-left: 18px;
       border-radius: 26px;
       line-height: 50px;
     }
     .van-field__button{
       font-size: 28px;color: #666;font-weight: 500;
     }
   }
 }
 .button-box{
   display: flex;
   margin: 25px 30px;
   /deep/ .van-button{flex: 1;height: 60px;}
   /deep/ .van-button--default{border: 2px solid #EEEEEE !important;background: #F5F5F5;margin-right: 25px;}
 }
</style>
